import React from 'react';
import { HolographicButton } from '../components/HolographicButton';
import { useCountdown } from '../hooks/useCountdown';
import { Check, Gift, Clock, ShieldCheck, Zap, BookOpen, Sparkles } from 'lucide-react';
export function ValueStack() {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown(600); // 10 minutes
  const trackAddToCart = () => {
    if (window.fbq) {
      window.fbq('track', 'AddToCart', {
        content_name: 'Kit de Supervivencia: Ventas por DM',
        currency: 'COP',
        value: 29999
      });
    }
  };
  return <section id="value-stack" className="py-20 bg-gradient-to-b from-surface to-white" data-id="element-257">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-258">
        {/* Header */}
        <div className="text-center mb-16" data-id="element-259">
          <span className="inline-flex items-center gap-2 bg-primary/10 text-primary font-semibold px-4 py-2 rounded-full text-sm mb-4" data-id="element-260">
            <Sparkles className="w-4 h-4" data-id="element-261" />
            Oferta por tiempo limitado
          </span>
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-graphite mb-4" data-id="element-262">
            Todo lo que recibes hoy
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-263">
            El sistema completo para transformar tus DMs en una máquina de
            ventas
          </p>
        </div>

        {/* Main Product Card */}
        <div className="bg-white rounded-3xl shadow-2xl border border-gray-100 overflow-hidden mb-12" data-id="element-264">
          {/* Product Header */}
          <div className="bg-gradient-to-r from-graphite to-gray-800 text-white p-8 md:p-10 relative overflow-hidden" data-id="element-265">
            <div className="absolute top-0 right-0 w-96 h-96 bg-primary opacity-10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-266"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent opacity-10 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-267"></div>

            <div className="relative z-10 flex flex-col md:flex-row items-center gap-8" data-id="element-268">
              <div className="w-32 h-32 bg-white/10 backdrop-blur-sm rounded-2xl flex items-center justify-center border border-white/20" data-id="element-269">
                <BookOpen className="w-16 h-16 text-white" data-id="element-270" />
              </div>
              <div className="text-center md:text-left" data-id="element-271">
                <h3 className="text-2xl md:text-3xl font-heading font-bold mb-2" data-id="element-272">
                  Kit de Supervivencia: Ventas por DM
                </h3>
                <p className="text-gray-300 text-lg" data-id="element-273">
                  Guía práctica para cerrar negocios con IA
                </p>
              </div>
            </div>
          </div>

          {/* Core Inclusions */}
          <div className="p-6 md:p-10" data-id="element-274">
            <h4 className="text-lg font-bold text-graphite mb-6 flex items-center gap-2" data-id="element-275">
              <BookOpen className="w-5 h-5 text-primary" data-id="element-276" />
              Incluido dentro del eBook:
            </h4>

            <div className="space-y-4 mb-8" data-id="element-277">
              <div className="flex items-start justify-between gap-4 p-4 bg-gray-50 rounded-xl" data-id="element-278">
                <div className="flex items-start gap-3" data-id="element-279">
                  <Check className="w-5 h-5 text-success flex-shrink-0 mt-0.5" data-id="element-280" />
                  <span className="text-gray-700 font-medium" data-id="element-281">
                    Ebook Estratégico: Manual paso a paso de la metodología
                    A.R.P.A.
                  </span>
                </div>
                <span className="text-gray-400 line-through text-sm whitespace-nowrap hidden md:inline-block" data-id="element-282">
                  $49.000
                </span>
              </div>

              <div className="flex items-start justify-between gap-4 p-4 bg-gray-50 rounded-xl" data-id="element-283">
                <div className="flex items-start gap-3" data-id="element-284">
                  <Check className="w-5 h-5 text-success flex-shrink-0 mt-0.5" data-id="element-285" />
                  <span className="text-gray-700 font-medium" data-id="element-286">
                    Tu 'Cerebro de Ventas' con IA: Prompts maestros para
                    configurar ChatGPT como cerrador 24/7
                  </span>
                </div>
                <span className="text-gray-400 line-through text-sm whitespace-nowrap hidden md:inline-block" data-id="element-287">
                  $69.000
                </span>
              </div>

              <div className="flex items-start justify-between gap-4 p-4 bg-gray-50 rounded-xl" data-id="element-288">
                <div className="flex items-start gap-3" data-id="element-289">
                  <Check className="w-5 h-5 text-success flex-shrink-0 mt-0.5" data-id="element-290" />
                  <span className="text-gray-700 font-medium" data-id="element-291">
                    Biblioteca de Guiones Anti-Visto: respuestas listas para
                    copiar/pegar ('Está caro', 'Lo voy a pensar', '¿Precio?')
                  </span>
                </div>
                <span className="text-gray-400 line-through text-sm whitespace-nowrap hidden md:inline-block" data-id="element-292">
                  $39.000
                </span>
              </div>

              <div className="flex items-start justify-between gap-4 p-4 bg-gray-50 rounded-xl" data-id="element-293">
                <div className="flex items-start gap-3" data-id="element-294">
                  <Check className="w-5 h-5 text-success flex-shrink-0 mt-0.5" data-id="element-295" />
                  <span className="text-gray-700 font-medium" data-id="element-296">
                    Protocolo de Rescate de 24 Horas: qué escribir al día
                    siguiente para recuperar ventas sin parecer pesado
                  </span>
                </div>
                <span className="text-gray-400 line-through text-sm whitespace-nowrap hidden md:inline-block" data-id="element-297">
                  $29.000
                </span>
              </div>

              <div className="flex items-start justify-between gap-4 p-4 bg-gray-50 rounded-xl" data-id="element-298">
                <div className="flex items-start gap-3" data-id="element-299">
                  <Check className="w-5 h-5 text-success flex-shrink-0 mt-0.5" data-id="element-300" />
                  <span className="text-gray-700 font-medium" data-id="element-301">
                    Checklist de Respuesta Rápida: para responder en menos de 3
                    minutos
                  </span>
                </div>
                <span className="text-gray-400 line-through text-sm whitespace-nowrap hidden md:inline-block" data-id="element-302">
                  $19.000
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Bonuses Section */}
        <div className="mb-12" data-id="element-303">
          <div className="text-center mb-8" data-id="element-304">
            <span className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500 to-orange-500 text-white font-bold px-6 py-3 rounded-full text-lg shadow-lg" data-id="element-305">
              <Gift className="w-5 h-5" data-id="element-306" />+ 2 BONOS DE ACCIÓN RÁPIDA
            </span>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-307">
            {/* Bonus 1 */}
            <div className="bg-white rounded-3xl shadow-xl border-2 border-primary/20 overflow-hidden transform transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl" data-id="element-308">
              <div className="bg-gradient-to-r from-primary/10 to-accent/10 p-4" data-id="element-309">
                <span className="inline-block bg-primary text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-310">
                  BONO #1 — GRATIS
                </span>
              </div>
              <div className="p-6" data-id="element-311">
                <div className="mb-6" data-id="element-312">
                  <img src="https://cdn.magicpatterns.com/uploads/9hmwwyHjduW17yvNSyGqxw/Portada_bono_1.png" alt="Mapa Anti-Visto - Diagnóstico Express de Conversaciones" className="w-full h-auto rounded-xl shadow-lg" data-id="element-313" />
                </div>
                <h5 className="font-heading font-bold text-xl text-graphite mb-2" data-id="element-314">
                  Mapa Anti‑Visto™
                </h5>
                <p className="text-gray-600 mb-4" data-id="element-315">
                  Diagnóstico Express de Conversaciones
                </p>
                <ul className="space-y-2" data-id="element-316">
                  <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-317">
                    <Check className="w-4 h-4 text-success flex-shrink-0 mt-0.5" data-id="element-318" />
                    <span data-id="element-319">Quick win inmediato: diagnóstico claro</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-320">
                    <Check className="w-4 h-4 text-success flex-shrink-0 mt-0.5" data-id="element-321" />
                    <span data-id="element-322">Destraba la objeción "ya intenté"</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-323">
                    <Check className="w-4 h-4 text-success flex-shrink-0 mt-0.5" data-id="element-324" />
                    <span data-id="element-325">Reduce frustración en la bandeja de entrada</span>
                  </li>
                </ul>
                <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-326">
                  <span className="text-gray-400 line-through text-sm" data-id="element-327">
                    Valor: $35.000
                  </span>
                  <span className="ml-2 text-success font-bold" data-id="element-328">INCLUIDO</span>
                </div>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white rounded-3xl shadow-xl border-2 border-accent/20 overflow-hidden transform transition-all duration-300 hover:scale-[1.02] hover:shadow-2xl" data-id="element-329">
              <div className="bg-gradient-to-r from-accent/10 to-primary/10 p-4" data-id="element-330">
                <span className="inline-block bg-accent text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-331">
                  BONO #2 — GRATIS
                </span>
              </div>
              <div className="p-6" data-id="element-332">
                <div className="mb-6" data-id="element-333">
                  <img src="https://cdn.magicpatterns.com/uploads/sFdWmqNg6k6HNmeEg6k2wh/Portada_bono_2.png" alt="Tablero Cierre-Fácil - Tracker de Seguimiento + Prioridades en 1 Página" className="w-full h-auto rounded-xl shadow-lg" data-id="element-334" />
                </div>
                <h5 className="font-heading font-bold text-xl text-graphite mb-2" data-id="element-335">
                  Tablero Cierre‑Fácil™
                </h5>
                <p className="text-gray-600 mb-4" data-id="element-336">
                  Tracker de Seguimiento en 1 Página
                </p>
                <ul className="space-y-2" data-id="element-337">
                  <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-338">
                    <Check className="w-4 h-4 text-success flex-shrink-0 mt-0.5" data-id="element-339" />
                    <span data-id="element-340">
                      Resuelve el dolor "tengo mensajes pero no cierro"
                    </span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-341">
                    <Check className="w-4 h-4 text-success flex-shrink-0 mt-0.5" data-id="element-342" />
                    <span data-id="element-343">Rutina diaria de 10 minutos</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-600" data-id="element-344">
                    <Check className="w-4 h-4 text-success flex-shrink-0 mt-0.5" data-id="element-345" />
                    <span data-id="element-346">Evita fugas invisibles de dinero</span>
                  </li>
                </ul>
                <div className="mt-4 pt-4 border-t border-gray-100" data-id="element-347">
                  <span className="text-gray-400 line-through text-sm" data-id="element-348">
                    Valor: $35.000
                  </span>
                  <span className="ml-2 text-success font-bold" data-id="element-349">INCLUIDO</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Card */}
        <div className="bg-gradient-to-br from-graphite via-gray-800 to-graphite rounded-3xl shadow-2xl overflow-hidden relative" data-id="element-350">
          {/* Decorative elements */}
          <div className="absolute top-0 right-0 w-64 h-64 bg-primary opacity-20 rounded-full blur-3xl" data-id="element-351"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent opacity-20 rounded-full blur-3xl" data-id="element-352"></div>

          <div className="relative z-10 p-8 md:p-12" data-id="element-353">
            {/* Value Summary */}
            <div className="text-center mb-8" data-id="element-354">
              <p className="text-gray-400 text-lg mb-2" data-id="element-355">
                Valor total de todo lo incluido:
              </p>
              <p className="text-white text-3xl md:text-4xl font-bold line-through opacity-60" data-id="element-356">
                $275.000 COP
              </p>
            </div>

            {/* Discount Badge */}
            <div className="flex justify-center mb-8" data-id="element-357">
              <div className="bg-gradient-to-r from-success to-emerald-500 text-white font-bold px-8 py-3 rounded-full text-xl shadow-lg transform -rotate-2" data-id="element-358">
                🔥 AHORRA 89% HOY
              </div>
            </div>

            {/* Final Price */}
            <div className="text-center mb-8" data-id="element-359">
              <p className="text-gray-300 text-lg mb-2" data-id="element-360">Tu inversión hoy:</p>
              <div className="flex items-baseline justify-center gap-2" data-id="element-361">
                <span className="text-6xl md:text-7xl font-heading font-extrabold text-white" data-id="element-362">
                  $29.999
                </span>
                <span className="text-gray-400 text-xl font-medium" data-id="element-363">COP</span>
              </div>
              <p className="text-accent font-medium mt-2" data-id="element-364">
                Pago único • Acceso de por vida
              </p>
            </div>

            {/* Countdown Timer */}
            <div className="flex items-center justify-center gap-3 bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl px-6 py-4 mb-8 max-w-md mx-auto" data-id="element-365">
              <Clock className="w-6 h-6 text-orange-400 animate-pulse" data-id="element-366" />
              <span className="text-gray-300 font-medium" data-id="element-367">
                Precio especial expira en:
              </span>
              <span className="font-mono text-2xl font-bold text-white tracking-wider" data-id="element-368">
                {hours}:{minutes}:{seconds}
              </span>
            </div>

            {/* CTA Button */}
            <div className="max-w-md mx-auto mb-8" data-id="element-369">
              <HolographicButton variant="success" size="xl" fullWidth href="https://krove.lat//cart/40650717790337:1" id="buyNowTop" onClick={trackAddToCart} className="animate-pulse-glow" data-id="element-370">
                Comprar ahora por $29.999
              </HolographicButton>
            </div>

            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 font-medium" data-id="element-371">
              <div className="flex items-center gap-2" data-id="element-372">
                <Zap className="w-5 h-5 text-accent" data-id="element-373" />
                <span data-id="element-374">Entrega inmediata</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-375">
                <BookOpen className="w-5 h-5 text-primary" data-id="element-376" />
                <span data-id="element-377">Acceso de por vida</span>
              </div>
              <div className="flex items-center gap-2" data-id="element-378">
                <ShieldCheck className="w-5 h-5 text-success" data-id="element-379" />
                <span data-id="element-380">Garantía 7 días</span>
              </div>
            </div>

            {/* Payment Logos */}
            <div className="flex items-center justify-center gap-6 mt-8 pt-8 border-t border-white/10" data-id="element-381">
              <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-382">
                <ShieldCheck className="w-4 h-4" data-id="element-383" />
                <span data-id="element-384">Pago seguro SSL</span>
              </div>
              <img src="https://cdn.magicpatterns.com/uploads/59p5MRYa4zpgtNfxhE81DX/logo_pse.png" alt="PSE" className="h-8 w-auto object-contain bg-white rounded px-2 py-1" data-id="element-385" />
              <img src="https://cdn.magicpatterns.com/uploads/bS7oX2gkbEbu3QXoYJmUU9/logo_nequi.png" alt="Nequi" className="h-7 w-auto object-contain bg-white rounded px-2 py-1" data-id="element-386" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}